import React from 'react';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';
import { Tooltip, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    width: 300,
    position: 'sticky',
    display: 'flex',
    flexDirection: 'column',
    borderLeft: '1px solid rgba(238, 238, 238, 1)',
    borderBottom: '1px solid rgba(238, 238, 238, 1)',

    [theme.breakpoints.down('lg')]: { width: 260 },
    [theme.breakpoints.down('md')]: { width: 220 },
    [theme.breakpoints.down('sm')]: { width: '100%', position: 'relative' },
  },

  header: {
    height: 153,
    backgroundColor: 'rgba(245, 245, 245, 1)',
    display: 'flex',

    [theme.breakpoints.down('md')]: { height: 130 },
    [theme.breakpoints.down('sm')]: { height: 110, flexDirection: 'column' },
  },

  headerSection: {
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    padding: 25,
    alignItems: 'center',

    [theme.breakpoints.down('md')]: { padding: 16 },
    [theme.breakpoints.down('sm')]: { width: '100%', padding: 12 },
  },

  vendorTitle: {
    fontSize: 12,
    fontWeight: 400,
    color: 'rgba(97, 97, 97, 1)',
    textOverflow: 'ellipsis',
    maxWidth: 95,
    whiteSpace: 'nowrap',
    overflow: 'hidden',

    [theme.breakpoints.down('md')]: { fontSize: 11, maxWidth: 80 },
    [theme.breakpoints.down('sm')]: { fontSize: 11, maxWidth: '100%' },
  },

  vendorValue: {
    fontSize: 12,
    textAlign: 'center',
    fontWeight: 400,
    textOverflow: 'ellipsis',
    maxWidth: 95,
    whiteSpace: 'nowrap',
    overflow: 'hidden',

    [theme.breakpoints.down('md')]: { fontSize: 11, maxWidth: 80 },
    [theme.breakpoints.down('sm')]: { fontSize: 12, maxWidth: '100%' },
  },

  content: {
    flexGrow: 1,
    borderLeft: '1px solid rgba(238, 238, 238, 1)',
  },

  contentInner: {
    display: 'flex',
    flexDirection: 'column',
    padding: '17px 16px',
    gap: 10,

    [theme.breakpoints.down('md')]: { padding: '14px 12px', gap: 8 },
    [theme.breakpoints.down('sm')]: { padding: '12px 10px', gap: 6 },
  },

  fieldRow: {
    height: 24,
    [theme.breakpoints.down('md')]: { height: 22 },
    [theme.breakpoints.down('sm')]: { height: 'auto' },
  },

  label: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '21px',
    color: 'rgba(117, 117, 117, 1)',
    textOverflow: 'ellipsis',
    maxWidth: 95,
    whiteSpace: 'nowrap',
    overflow: 'hidden',

    [theme.breakpoints.down('md')]: { fontSize: 11, maxWidth: 80 },
    [theme.breakpoints.down('sm')]: { fontSize: 11, maxWidth: '100%' },
  },

  colon: {
    fontWeight: 400,
    color: 'rgba(117, 117, 117, 1)',
    fontSize: 14,
    lineHeight: '22px',

    [theme.breakpoints.down('md')]: { fontSize: 13 },
    [theme.breakpoints.down('sm')]: { fontSize: 12 },
  },

  tabContainer: {
    height: 36,
    display: 'flex',

    [theme.breakpoints.down('md')]: { height: 32 },
    [theme.breakpoints.down('sm')]: { height: 30 },
  },

  tab: {
    width: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    cursor: 'pointer',
  },

  tabActive: {
    borderBottom: '1px solid #3F51B5',
    '& $tabText': { color: 'rgba(63, 81, 181, 1)' },
  },

  tabInactive: {
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    '& $tabText': { color: 'rgba(80, 87, 99, 1)' },
  },

  tabText: {
    fontSize: 13,
    fontWeight: 400,
    [theme.breakpoints.down('md')]: { fontSize: 12 },
    [theme.breakpoints.down('sm')]: { fontSize: 11 },
  },

  // ===== CHIPS =====
  customChip: {
    borderRadius: 100,
    color: 'rgba(46, 125, 50, 1)',
    border: '1px solid rgba(46, 125, 50, 1)',
  },

  customChip1: {
    borderRadius: 24,
    height: 24,
    padding: '5px 0px',
    fontSize: 12,
    border: '1px solid #BDBDBD',
    color: '#BDBDBD',
    maxWidth: 115,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',

    [theme.breakpoints.down('md')]: { fontSize: 11, maxWidth: 100 },
    [theme.breakpoints.down('sm')]: { fontSize: 11, maxWidth: '100%' },
  },

  customChip2: {
    borderRadius: 24,
    height: 24,
    fontSize: 12,
    padding: '5px 0px',
    color: 'rgba(2, 136, 209, 1)',
    border: '1px solid rgba(2, 136, 209, 1)',
    maxWidth: 115,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',

    [theme.breakpoints.down('md')]: { fontSize: 11, maxWidth: 100 },
    [theme.breakpoints.down('sm')]: { fontSize: 11, maxWidth: '100%' },
  },

  customChip3: {
    borderRadius: 24,
    height: 24,
    fontSize: 12,
    padding: '5px 0px',
    color: 'rgba(239, 108, 0, 1)',
    border: '1px solid rgba(239, 108, 0, 1)',
    maxWidth: 115,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',

    [theme.breakpoints.down('md')]: { fontSize: 11, maxWidth: 100 },
    [theme.breakpoints.down('sm')]: { fontSize: 11, maxWidth: '100%' },
  },

  customChip4: {
    borderRadius: 24,
    fontSize: 12,
    height: 24,
    padding: '5px 0px',
    backgroundColor: 'rgba(238, 238, 238, 1)',
    border: 'none',
    maxWidth: 115,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',

    [theme.breakpoints.down('md')]: { fontSize: 11, maxWidth: 100 },
    [theme.breakpoints.down('sm')]: { fontSize: 11, maxWidth: '100%' },
  },
}));


const SideBarViewer = (props) => {
  const { data, formData, tableData, blockState, setActiveTab, activeTab } = props;

  const { chartData } = data || {};

  const { LinkedObligationdataElements, LinkedContractsdataElements, LinkedSpenddataElements, PortfolioInfo, VendorInfo } = chartData || {};

  const classes = useStyles();

  const formatAmount = (val, isAmountField, showDoller) => {
    if (isAmountField && showDoller) {
      const cleaned = String(val).replace(/[$,]/g, '').trim();
      const num = Number(cleaned);
      if (!isNaN(num)) {
        return `$${num.toLocaleString()}`;
      }
    }
    return val;
  };

  return (
    <div className={classes.root}>
      {/* Header */}
      <div className={classes.header}>
        {props?.topHeaderdataElements.length > 0 ? props?.topHeaderdataElements.map((item) => (
          <div className={classes.headerSection}>
            <div style={{ border: '1px solid rgba(233, 235, 245, 1)', borderRadius: '4px', padding: '4px', backgroundColor: 'rgba(255, 255, 255, 1)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <img src={'/media/svg/noVendorImages.svg'} alt="Vendor" width="60" height="60" />
            </div>
            <div>
              <Typography className={classes.vendorTitle}>{item.label}</Typography>
              <Typography className={classes.vendorValue}>
                <Tooltip
                  title={
                    tableData[item.value]
                      ? typeof tableData[item.value] === "object"
                        ? tableData[item.value]?.value || "-"
                        : tableData[item.value]
                      : "-"
                  }
                  arrow
                >
                  <span>
                    {tableData[item.value]
                      ? typeof tableData[item.value] === "object"
                        ? tableData[item.value]?.value || "-"
                        : tableData[item.value]
                      : "-"}
                  </span>
                </Tooltip>
              </Typography>
            </div>

          </div>
        ))
          : null
        }
      </div>

      {/* Obligations */}
      <div className={classes.content}>
        <div className={classes.contentInner}>
          {LinkedObligationdataElements.map((res) => (
            <div className={classes.fieldRow}>
              <Grid container>
                <Grid item xs={6}>
                  <Tooltip title={res.label} arrow>
                    <Typography className={classes.label}>{res.label}</Typography>
                  </Tooltip>
                </Grid>
                <Grid item xs={1}><Typography className={classes.colon}>:</Typography></Grid>
                <Grid item xs={5}>
                  {blockState[res.value] ? (
                    <Tooltip title={blockState[res.value]} arrow>
                      <Chip label={blockState[res.value]} variant="outlined" className={classes.customChip4} />
                    </Tooltip>
                  ) : "-"}
                </Grid>
              </Grid>
            </div>
          ))}
        </div>

        {/* Tabs */}
        <div className={classes.tabContainer}>
          {["contract", "spend"].map((tab) => (
            <div
              key={tab}
              className={`${classes.tab} ${activeTab === tab ? classes.tabActive : classes.tabInactive}`}
              style={{ boxSizing: 'border-box' }}
              onClick={() => setActiveTab(tab)}
            >
              <Typography className={classes.tabText}>
                {tab === "contract" ? "Contract Details" : "Spend Details"}
              </Typography>
            </div>
          ))}
        </div>

        {/* Contract/Spend Details */}
        <div className={classes.contentInner}>
          {activeTab === "contract" &&
            LinkedContractsdataElements.map((data) => {
              const rawValue = typeof tableData[data.value] === 'object' ? tableData[data.value]?.value : tableData[data.value];
              const displayValue = formatAmount(rawValue, data.isAmountField, data.showDoller);
              return (
                <div className={classes.fieldRow}>
                  <Grid container>
                    <Grid item xs={6}>
                      <Tooltip title={data.label} arrow>
                        <Typography className={classes.label}>{data.label}</Typography>
                      </Tooltip>
                    </Grid>
                    <Grid item xs={1}><Typography className={classes.colon}>:</Typography></Grid>
                    <Grid item xs={5}>
                      {displayValue ? (
                        <Tooltip title={displayValue} arrow>
                          <span>
                            {data.isChipEnable ? (
                              <Chip label={displayValue} variant="outlined" className={classes[data.chipcss]} />
                            ) : displayValue}
                          </span>
                        </Tooltip>
                      ) : "-"}
                    </Grid>
                  </Grid>
                </div>
              );
            })}
          {activeTab === "spend" &&
            LinkedSpenddataElements.map((data) => {
              const rawValue = typeof blockState[data.value] === 'object' ? blockState[data.value]?.value : blockState[data.value];
              const displayValue = formatAmount(rawValue, data.isAmountField, data.showDoller);
              return (
                <div className={classes.fieldRow}>
                  <Grid container>
                    <Grid item xs={6}>
                      <Tooltip title={data.label} arrow>
                        <Typography className={classes.label}>{data.label}</Typography>
                      </Tooltip>
                    </Grid>
                    <Grid item xs={1}><Typography className={classes.colon}>:</Typography></Grid>
                    <Grid item xs={5}>
                      {displayValue ? (
                        <Tooltip title={displayValue} arrow>
                          <span>
                            {data.isChipEnable ? (
                              <Chip label={displayValue} variant="outlined" className={classes[data.chipcss]} />
                            ) : displayValue}
                          </span>
                        </Tooltip>
                      ) : "-"}
                      {/* <Tooltip title={displayValue} arrow>
                        <span>
                          {data.isChipEnable ? (
                            <Chip label={displayValue} variant="outlined" className={classes[data.chipcss]} />
                          ) : displayValue}
                        </span>
                      </Tooltip> */}
                    </Grid>
                  </Grid>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default SideBarViewer;
